<template>
  <v-app :id="'inspire-'+page">
    <v-app-bar 
      app 
      color="success" 
      dark
      v-if="$msal.isAuthenticated()"
    >
      <div class="d-flex align-center">
        <img class="bienestar-img" :src="require('@/assets/img/bienestar1.png')"> 
        <span class="bienestar-title-h1">
          <div v-if="false">
            <span class="bienestar-title-h1-1">Recursos Humanos
            </span><br>
            <span class="bienestar-title-h1-2">Bienestar Integral</span>
          </div>
            <span class="bienestar-title-h1-1">Bienestar
            </span><br>
            <span class="bienestar-title-h1-2">Laureate</span>
        </span>
      </div>
      <v-spacer></v-spacer>
      <v-btn id="button-logout" text @click="logout()">
        <span class="mr-2">Cerrar sesión</span>
        <v-icon>mdi-open-in-new</v-icon>
      </v-btn>
      <v-btn id="icons-logout" text @click="logout()">
        <v-icon>mdi-open-in-new</v-icon>
      </v-btn>
    </v-app-bar>
    <v-main>
      <v-container class="mt-2 mb-5">
        <router-view/>
      </v-container>
    </v-main>
    <v-footer
      v-if="$msal.isAuthenticated()"
      :padless="true"
    >
      <v-card
        flat
        tile
        width="100%"
      >
        <!--
          <v-card-text class="green darken-1 text-center">
            <v-btn
              v-for="icon in icons"
              :key="icon"
              class="mx-4"
              icon
            >
              <v-icon size="24px">
                {{ icon }}
              </v-icon>
            </v-btn>
          </v-card-text>
          <v-divider class="green darken-3"></v-divider>
        -->
        <v-card-text class="green darken-3 white--text text-center">
          <span class="footer_made">Made By</span> <span class="footer_made_bold">HR Development Area</span>
          <br>
          <span class="footer_made">©{{ new Date().getFullYear() }} —  Laureate Education, Inc. Legal Information</span>
        </v-card-text>
      </v-card>
    </v-footer>
  </v-app>
</template>
<script>
  export default {
    name: 'App',
    data(){
      return{
        page: ""
      }
    },
    //
    methods: {
      logout(){
        this.$msal.signOut();
      }
    },
    //
    created() {
      if(this.$msal.isAuthenticated()){
        this.page = "app"
      }
      else{
        this.page = "login"
      }
    }
  };
</script>
<style lang="css">
  @import './assets/styles/core.css';
</style>
